"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerLayoutSideNavigation = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _Divider = require("../../components/Divider/Divider");
var _TextButton = require("../../components/Button/TextButton");
var _AuthProvider = require("../AuthProvider/AuthProvider");
var _reactRouterDom = require("react-router-dom");
var _components = require("../../components");
var _utils = require("../../utils");
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var adminStyles = _constants.MANAGER_LAYOUT_STYLING.adminStyles,
  clinicianStyles = _constants.MANAGER_LAYOUT_STYLING.clinicianStyles;
var NavigationItem = function NavigationItem(_ref) {
  var className = _ref.className,
    item = _ref.item,
    managerStyles = _ref.managerStyles,
    menuCollapsed = _ref.menuCollapsed,
    children = _ref.children,
    iconClassName = _ref.iconClassName;
  var _useLocation = (0, _reactRouterDom.useLocation)(),
    pathname = _useLocation.pathname;
  var icon = item.icon,
    route = item.route,
    routePatterns = item.patterns,
    exactMatch = item.exactMatch;
  var navItemDefaultClassNames = managerStyles.navItemDefaultClassNames,
    navItemActiveClassNames = managerStyles.navItemActiveClassNames;
  var itemActive = (0, _reactRouterDom.matchPath)(pathname, {
    path: route,
    exact: exactMatch
  }) || (0, _lodash.some)(routePatterns, function (pattern) {
    return (0, _reactRouterDom.matchPath)(pathname, {
      path: pattern,
      exact: exactMatch
    });
  });
  var activeClasses = itemActive ? navItemActiveClassNames : 'tw-label-light';
  var navItem = /*#__PURE__*/_react.default.createElement(_TextButton.TextButton, {
    icon: icon,
    route: route,
    type: "light",
    size: "large",
    className: (0, _classnames.default)(className, navItemDefaultClassNames, activeClasses),
    iconPosition: "left",
    iconSize: 32,
    iconClassName: (0, _classnames.default)(iconClassName, 'mr-[15px]')
  }, children);
  return /*#__PURE__*/_react.default.createElement("li", null, menuCollapsed ? /*#__PURE__*/_react.default.createElement(_components.Tooltip, {
    placement: "right",
    title: item.label
  }, navItem) : navItem);
};
var SideNavigationHeader = function SideNavigationHeader(_ref2) {
  var menuCollapsed = _ref2.menuCollapsed,
    setMenuCollapsed = _ref2.setMenuCollapsed;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-start h-app-header-height pl-[33px] border-0 border-b-[1px] border-solid border-grey-15"
  }, !menuCollapsed && /*#__PURE__*/_react.default.createElement("div", {
    className: "mr-[65px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "monument-logo",
    size: 32
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex cursor-pointer items-center",
    onClick: function onClick() {
      return setMenuCollapsed(!menuCollapsed);
    }
  }, !menuCollapsed && /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "caret-left-medium-16",
    className: "mr-[6px] mb-[2px]",
    size: 16
  }), /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "menu-small",
    size: 32,
    className: "mt-[14px]"
  })));
};
var ManagerLayoutSideNavigation = function ManagerLayoutSideNavigation(_ref3) {
  var className = _ref3.className,
    itemClassName = _ref3.itemClassName,
    items = _ref3.items,
    menuCollapsed = _ref3.menuCollapsed,
    setMenuCollapsed = _ref3.setMenuCollapsed,
    _ref3$showLogout = _ref3.showLogout,
    showLogout = _ref3$showLogout === void 0 ? true : _ref3$showLogout;
  var _useAuth = (0, _AuthProvider.useAuth)(),
    user = _useAuth.user,
    logout = _useAuth.logout;
  var isAdminManager = (0, _utils.isAdmin)(user);
  var managerStyles = isAdminManager ? adminStyles : clinicianStyles;
  var navItemDefaultClassNames = managerStyles.navItemDefaultClassNames;
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: (0, _classnames.default)(className, 'relative text-white h-full pb-[20px]', menuCollapsed ? 'w-app-menu-collapsed' : 'w-app-menu-open', isAdminManager ? 'bg-green1-65' : 'bg-blue1-60')
  }, /*#__PURE__*/_react.default.createElement(SideNavigationHeader, {
    setMenuCollapsed: setMenuCollapsed,
    menuCollapsed: menuCollapsed
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-none p-0 m-0"
  }, (0, _lodash.map)(items, function (item, i) {
    return /*#__PURE__*/_react.default.createElement(NavigationItem, {
      key: i,
      item: item,
      className: ((0, _classnames.default)(itemClassName), 'py-3'),
      iconClassName: isAdminManager ? 'text-green1-15' : 'text-blue1-20',
      managerStyles: managerStyles,
      menuCollapsed: menuCollapsed
    }, !menuCollapsed && item.label);
  })), /*#__PURE__*/_react.default.createElement(_Divider.Divider, {
    className: (0, _classnames.default)(isAdminManager ? 'my-0' : 'my-[24px]')
  }), showLogout && /*#__PURE__*/_react.default.createElement(_TextButton.TextButton, {
    type: "light",
    size: "large",
    className: (0, _classnames.default)(className, navItemDefaultClassNames, 'tw-label-light py-3'),
    icon: "logout",
    iconPosition: "left",
    iconSize: 32,
    iconClassName: "text-blue1-20 mr-[15px]",
    onClick: function onClick() {
      return (0, _utils.showLogoutConfirm)(logout);
    }
  }, !menuCollapsed && 'Logout'));
};
exports.ManagerLayoutSideNavigation = ManagerLayoutSideNavigation;
ManagerLayoutSideNavigation.propTypes = {
  className: _propTypes.default.string,
  itemClassName: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    route: _propTypes.default.string,
    label: _propTypes.default.string,
    patterns: _propTypes.default.arrayOf(_propTypes.default.string)
  })),
  menuCollapsed: _propTypes.default.bool,
  setMenuCollapsed: _propTypes.default.func,
  showLogout: _propTypes.default.bool
};